import { writable } from "svelte/store"

/**
 * Represents a document object.
 * @class
 */
export class AuthObject {
  /**
   * Constructs a new AuthObject instance.
   * @constructor
   */
  constructor() {
    /**
     * Indicates the active component.
     * @type {String}
     * @default null
     */
    this.token = null
  }
}

/**
 * @type {AuthObj} - Retrieving the single publish data from local storage
 */
let stats = localStorage.getItem("P2bAuthStore")

if (typeof stats != "Object") {
  try {
    // Parsing the value as JSON
    stats = JSON.parse(stats)
    if (!stats) {
      // Throwing an error if the parsed value is null
      throw new Error("Document value is null")
    }
  } catch (error) {
    // console.error(error)
    // Initializing stats with a new instance of the AuthObject class
    stats = new AuthObject()
  }
}

/**
 * @typedef {Object} AuthObj - Authentication stats.
 * @type {Object}
 * Authentication stats.

 * @property {String} token - signing token.
 * /
 
/**
 * @type {import("svelte/store").Writable<Authentication>}
 */

const Authentication = writable(stats)

/**
 * Updates the value of "P2bAuthStore" in the localStorage.
 * @param {object} stats - The stats object to be stored.
 */
export const updateAuth = (stats) => {
  // Stringify the stats object and store it in the localStorage
  localStorage.setItem("P2bAuthStore", JSON.stringify(stats))
}
export default Authentication
